var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dt-search-bars"},[_c('div',{staticClass:"dt-search-bar-search-sec"},[_vm._t("filterSlot")],2),_c('div',{staticClass:"dt-search-bar-add-sec"},[_vm._t("addFilterSlot")],2),_c('div',{staticClass:"dt-search-bar-btn-sec"},[_vm._t("buttonSlot")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }